    document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".pairProducts-grid-wrapper");
  
  // Check if wrapper exists
  if (!wrapper) return;
  
  const grid = wrapper.querySelector(".pairProducts-grid-items");
  
  // Check if pairProducts-grid-items exists
  if (!grid) return;
  
  const leftArrow = wrapper.querySelector(".grid-arrow.left");
  const rightArrow = wrapper.querySelector(".grid-arrow.right");

  // Get the width of a single product card
  const productCard = grid.querySelector(".perfekto-gridu");
  const cardWidth = productCard.offsetWidth + parseInt(window.getComputedStyle(productCard).marginRight);

  // Update arrow states
  function updateArrows() {
    leftArrow.classList.toggle("disabled", grid.scrollLeft === 0);
    rightArrow.classList.toggle(
      "disabled",
      grid.scrollLeft + grid.clientWidth >= grid.scrollWidth
    );
  }

  // Scroll to the left
  leftArrow.addEventListener("click", () => {
    if (grid.scrollLeft > 0) {
      grid.scrollLeft -= cardWidth; // Scroll by the width of one card
    }
    updateArrows();
  });

  // Scroll to the right
  rightArrow.addEventListener("click", () => {
    if (grid.scrollLeft + grid.clientWidth < grid.scrollWidth) {
      grid.scrollLeft += cardWidth; // Scroll by the width of one card
    }
    updateArrows();
  });

  // Listen for scroll events
  grid.addEventListener("scroll", updateArrows);

  // Initialize arrow states
  updateArrows();
});

  